import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_GISConnectResultList',
  name: 'CDS_VF_GISConnectResultList',
  component: App,
  meta: {
    pageProperty: {
      title: 'ArcGIS連携ログ',
      controller: 'CDS_CTR_GISConnectResultList',
    },
    guardRules: [user],
  },
};
